"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerClient = void 0;
const tslib_1 = require("tslib");
const new_crud_client_1 = require("./new.crud.client");
class PartnerClient extends new_crud_client_1.NewCrudClient {
    constructor() {
        super(...arguments);
        this.urlTemplate = '/v1/partners';
    }
    getUsersByPartner(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { partnerId } = request;
            const response = yield this.httpGet(`/v1/partners/${partnerId}/users?${this.getQueryString(request)}`);
            return response.payload || [];
        });
    }
    getAccountsByPartner(partnerId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/partners/${partnerId}/accounts`);
            return response.payload || [];
        });
    }
    getProjects(partnerId, searchRequest) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const baseUrl = `/v1/partners/${partnerId}/projects`;
            const queryString = this.getQueryString(searchRequest !== null && searchRequest !== void 0 ? searchRequest : {});
            const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getPartnerUsersByProjectId(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/partners/projects/${projectId}/users`);
            return response.payload || [];
        });
    }
}
exports.PartnerClient = PartnerClient;
//# sourceMappingURL=partner.client.js.map